// 定义埋点混入
const webBuryPoint = {
  data () {
    return {
      events: [],
      serverUrl: 'YOUR_SERVER_URL',
      initialized: false
    }
  },
  mounted () {
    var self = this
    window.addEventListener('beforeunload', function (event) {
      if (event.currentTarget.performance.navigation.type === 1) {
        self.closePage('refreshClose')
      } else {
        self.closePage('webclose')
      }
    })

    // 首次进入页面有问题 需要判断
    // if (!this.initialized) {
    //   this.trackPageView('')
    //   this.initialized = true
    // }
  },
  methods: {
    // 获取公共参数
    commonParam (paramLs, type = 'in') {
      // 时间
      var loadPageStartTime = ''
      if (paramLs.loadPageStartTime !== '' && paramLs.loadPageStartTime !== undefined) {
        loadPageStartTime = paramLs.loadPageStartTime
      }
      var loadPageEndTime = ''
      if (paramLs.loadPageEndTime !== '' && paramLs.loadPageEndTime !== undefined) {
        loadPageEndTime = paramLs.loadPageEndTime
      }
      var pageClickTime = ''
      if (paramLs.pageClickTime !== '' && paramLs.pageClickTime !== undefined) {
        pageClickTime = paramLs.pageClickTime
      }
      var clickData = ''
      if (paramLs.clickData !== '' && paramLs.clickData !== undefined) {
        clickData = paramLs.clickData
      }
      // 请求 返回等
      var request = ''
      if (paramLs.request !== '' && paramLs.request !== undefined) {
        request = paramLs.request
      }
      var result = ''
      if (paramLs.result !== '' && paramLs.result !== undefined) {
        result = paramLs.result
      }
      var response = ''
      if (paramLs.response !== '' && paramLs.response !== undefined) {
        response = paramLs.response
      }
      var pageType = ''
      if (paramLs.pageType !== '' && paramLs.pageType !== undefined) {
        pageType = paramLs.pageType
      }
      var pageTypeExt = ''
      if (paramLs.pageTypeExt !== '' && paramLs.pageTypeExt !== undefined) {
        pageTypeExt = paramLs.pageTypeExt
      }
      var paramType = ''
      if (paramLs.type !== '' && paramLs.type !== undefined) {
        paramType = paramLs.type
      }
      var page = ''
      if (paramLs.page !== '' && paramLs.page !== undefined) {
        page = paramLs.page
      }
      var pageSource = ''
      if (paramLs.page_source !== '' && paramLs.page_source !== undefined) {
        pageSource = paramLs.page_source
      }
      var outPageTime = ''
      if (paramLs.outPageTime !== '' && paramLs.outPageTime !== undefined) {
        outPageTime = paramLs.outPageTime
      }
      var inPageTime = ''
      if (paramLs.innterPageTime !== '' && paramLs.innterPageTime !== undefined) {
        inPageTime = paramLs.innterPageTime
      }

      //
      var url = new URL(window.location.href)
      // 解析 URL 参数
      var params = new URLSearchParams(url.search)
      var source = params.get('source')
      if (source === '' || source === undefined || source === null) {
        source = localStorage.getItem('source')
      }
      if (source === '' || source === undefined || source === null) {
        source = 'roompai'
      }

      // user_token
      var useragent = navigator.userAgent
      // console.log('浏览器设备信息为: ' + useragent)
      // console.log('屏幕分辨率为: ' + window.screen.width + 'x' + window.screen.height)
      // console.log('浏览器语言为: ' + navigator.language || navigator.userLanguage)

      // 用户 token
      var roompaiStorageToken = localStorage.getItem('roompaiStorageToken')
      if (roompaiStorageToken === null || roompaiStorageToken === undefined) {
        roompaiStorageToken = this.$md5(useragent + paramLs.innterPageTime)
        localStorage.setItem('roompaiStorageToken', roompaiStorageToken)
      }

      // 识别码
      var IdentificationCode = this.IdentificationCode()

      // 用户设备等信息
      var usInfo = this.common.encryptionData({}, this)
      var client = (usInfo.flag === 'mobile') ? 'mobile' : 'pc'

      // 上一个页面
      var pageInfoData = sessionStorage.getItem('pageInfoData')
      if (pageInfoData !== '{}' && pageInfoData !== null) {
        var pageInfoArr = JSON.parse(pageInfoData)
        page = pageInfoArr.toPage
      }
      if (page === '') {
        page = this.$router.currentRoute.name
      }

      // 如果是进入页面 需要把进入页面时间记录下来
      if (type === 'in') {
        if (pageInfoData !== '{}' && pageInfoData !== null) {
          pageInfoArr = JSON.parse(pageInfoData)
          pageInfoArr.inPageTime = paramLs.innterPageTime
          var pageInfoJson = JSON.stringify(pageInfoArr)
          sessionStorage.setItem('pageInfoData', pageInfoJson)

          if (pageInfoArr.fromPage !== '' || pageInfoArr.fromPage !== null) {
            pageSource = pageInfoArr.fromPage
          }
        }
      }

      if (type === 'data') {
        if (pageInfoData !== '{}' && pageInfoData !== null) {
          pageInfoArr = JSON.parse(pageInfoData)
          inPageTime = pageInfoArr.inPageTime
        }
      }

      // 离开页面 需要 读取 离开时间
      if (type === 'out') {
        if (pageInfoData !== '{}' && pageInfoData !== null) {
          pageInfoArr = JSON.parse(pageInfoData)
          inPageTime = pageInfoArr.inPageTime
        }
        if (inPageTime === undefined || inPageTime === null) {
          inPageTime = ''
        }
      }

      // 语言 货币 站点
      var language = this.common.languageSet()
      var currency = this.common.currencySet()
      var site = this.common.siteSet()

      var ext = {
        'skip_url': window.location.href
      }

      var data = {
        'IdentificationCode': IdentificationCode,
        'user_token': roompaiStorageToken,
        'page': page,
        'client': client,
        'useragent': useragent,
        // 'platform': '',
        // 'platfrom_version': '',
        // 'browser': '',
        // 'ip': '',
        // 'country': '',
        // 'province': '',
        // 'city': '',
        // 'district': '',
        // 'street': '',
        // 'create_time': '',
        'page_source': pageSource,
        'type': paramType,
        'language': language,
        'currency': currency,
        'website': site,
        'request': request,
        'result': result,
        'response': response,
        'page_type': pageType,
        'page_type_ext': pageTypeExt,
        'click_data': clickData,
        'innter_page_time': inPageTime,
        'out_page_time': outPageTime,
        'loading_page_start_time': loadPageStartTime,
        'loading_page_end_time': loadPageEndTime,
        'page_click_time': pageClickTime,
        'ext': ext
      }
      return data
    },
    // 识别码
    IdentificationCode (requesttType = '') {
      const navigatorInfo = {
        canvasData: this.common.canvasFingerprint(),
        userAgent: window.navigator.userAgent,
        platform: window.navigator.platform,
        language: window.navigator.language,
        hardwareConcurrency: window.navigator.hardwareConcurrency,
        vendor: window.navigator.vendor,
        numberingSystem: Intl.DateTimeFormat().resolvedOptions().numberingSystem,
        timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        width: window.screen.width,
        height: window.screen.height,
        plugins: this.common.getPluginsInfo(window.navigator.plugins),
        connection: this.common.getConnectionInfo(window.navigator.connection),
        WebGL: this.common.generateWebGLFingerprint(),
        webFont: this.common.webFont()

        // appVersion: window.navigator.appVersion,
        // appName: window.navigator.appName,
        // appCodeName: window.navigator.appCodeName,
        // languages: window.navigator.languages,
        // cookieEnabled: window.navigator.cookieEnabled,
        // doNotTrack: window.navigator.doNotTrack,
        // onLine: window.navigator.onLine,
        // geolocation: window.navigator.geolocation,
        // mediaDevices: window.navigator.mediaDevices,
        // vendorSub: window.navigator.vendorSub,
        // product: window.navigator.product,
        // productSub: window.navigator.productSub,
        // userAgentData: window.navigator.userAgentData,
        // mimeTypes: this.getMimeTypesInfo(window.navigator.mimeTypes),
        // maxTouchPoints: window.navigator.maxTouchPoints,
        // clipboard: this.getClipboardInfo(window.navigator.clipboard)
      }

      // 拼接字符串
      var navigatorInfoConcat = this.common.concatenateValues(navigatorInfo)
      var navigatorInfoMd5 = this.$md5(navigatorInfoConcat)
      // console.log(navigatorInfoMd5)
      var hashResultBase64 = btoa(navigatorInfoConcat).toString()
      // console.log(hashResultBase64)

      if (requesttType === 'MD5') {
        return navigatorInfoMd5
      }
      return hashResultBase64
    },
    // 追踪页面访问事件
    trackPageView (page) {
      var innterPageTime = parseInt(new Date().getTime())
      var data = {
        'page': page,
        'page_source': '',
        'type': 'pageview',
        'request': '', // 请求
        'result': '', // 结果
        'response': '', // 返回
        'pageType': 'inpage', // 操作的数据
        'pageTypeExt': '', // 操作的数据值
        'innterPageTime': innterPageTime,
        'outPageTime': '',
        'loadPageStartTime': '',
        'loadPageEndTime': '',
        'ext': ''
      }
      var params = this.commonParam(data, 'in')
      var paramsThicken = this.common.encryptionData(params, this)
      this.sendEventData(paramsThicken)
    },
    // 页面加载完成记录
    loadPageView (request, response, requestTime, responseTime, pageTypeExt = '') {
      var data = {
        'page': '',
        'page_source': '',
        'type': 'pageview',
        'request': request, // 请求
        'result': response.flag, // 结果
        'response': response, // 返回
        'pageType': 'loaded', // 操作的数据
        'pageTypeExt': pageTypeExt, // 操作的数据值
        'innterPageTime': '',
        'outPageTime': '',
        'loadPageStartTime': requestTime,
        'loadPageEndTime': responseTime,
        'ext': ''
      }
      var params = this.commonParam(data, 'data')
      var paramsThicken = this.common.encryptionData(params, this)
      this.sendEventData(paramsThicken)
    },
    // 点击操作 触发的方法
    clickPageAction (pageType, pageTypeExt = '', data = {}, request = {}, response = {}) {
      var pageClickTime = parseInt(new Date().getTime())
      var buttonData = {
        'page': '',
        'page_source': '',
        'type': 'button',
        'request': request, // 请求
        'result': response.flag, // 结果
        'response': response, // 返回
        'pageType': pageType, // 操作的数据
        'pageTypeExt': pageTypeExt, // 操作的数据值
        'clickData': data,
        'pageClickTime': pageClickTime,
        'ext': ''
      }
      var params = this.commonParam(buttonData, 'data')
      var paramsThicken = this.common.encryptionData(params, this)
      this.sendEventData(paramsThicken)
    },
    // 关闭网页触发 方法
    closePage (operateType) {
      // 如果已经提交过数据，则不执行下面的操作
      var isSubmitting = localStorage.getItem('isSubmitting')
      if (isSubmitting) {
        return
      }
      // 存储标记值
      localStorage.setItem('isSubmitting', true)

      var pageCloseTime = parseInt(new Date().getTime())
      var data = {
        'page_source': '',
        'type': 'pageview',
        'request': operateType, // 请求
        'result': '', // 结果
        'response': '', // 返回
        'pageType': 'outpage', // 操作的数据
        'pageTypeExt': '', // 操作的数据值
        'inPageTime': '',
        'outPageTime': pageCloseTime,
        'loadPageStartTime': '',
        'loadPageEndTime': '',
        'ext': ''
      }

      var params = this.commonParam(data, 'out')
      var paramsThicken = this.common.encryptionData(params, this)
      this.sendEventData(paramsThicken)
    },
    // 发送事件数据到服务器 -- 暂无埋点，所以注释掉
    sendEventData (data) {
      // const xhr = new XMLHttpRequest()

      // xhr.open('POST', '/api/webBuryPoint')
      // xhr.setRequestHeader('Content-Type', 'application/json')

      // xhr.onload = function () {
      //   localStorage.removeItem('isSubmitting')
      // }
      // xhr.onerror = function () {
      //   localStorage.removeItem('isSubmitting')
      // }

      // xhr.send(JSON.stringify(data))
    }
  }
}

export default webBuryPoint



// WEBPACK FOOTER //
// ./src/util/webBuryPoint.js